import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import screenProps from '../../screenProps'
import SubOrderModal from '../../../../Modals/SubOrder'

import Header from './Components/Header'
import Table from './Components/Table'

const SubOrders = props => {

  const {
    filters,
    subOrderModal,
    componentDidMount,
    onCloseSubOrderModal,
  } = props

  useEffect(() => {
    componentDidMount()
  }, [filters])

  return (
    
    <React.Fragment>

      <Header />

      <Table />

      {subOrderModal.show && (
        <SubOrderModal
          {...subOrderModal}
          subcontractorId={Number(screenProps().match.params.id)}
          projectId={filters.projectId}
          onClose={onCloseSubOrderModal}
        />
      )}

    </React.Fragment>

  )

}

SubOrders.propTypes = {
  filters: PropTypes.object.isRequired,
  subOrderModal: PropTypes.object.isRequired,
  componentDidMount: PropTypes.func.isRequired,
  onCloseSubOrderModal: PropTypes.func.isRequired,
}

export default SubOrders
